import React, { CSSProperties, useCallback } from "react";

import { IconName } from "../components";
import { useI18n } from "../lib/i18n/i18n_provider";
import { SpaceOffering } from "./api";
import { Picker } from "./picker";

export interface MultiPassPickerProps {
  multiPasses: SpaceOffering[];
  placeholder?: string;
  disabled?: boolean;
  value?: string;
  onChange: (addOnID: string, spaceOfferingID: string) => void;
  override?: {
    root?: { style?: CSSProperties };
    view?: { style?: CSSProperties };
    arrow?: { style?: CSSProperties };
  };
  icon?: IconName;
}

export function MultiPassPicker(props: MultiPassPickerProps) {
  const { fbt } = useI18n();
  const {
    value,
    multiPasses,
    onChange,
    disabled,
    override,
    placeholder = fbt("Select # of entries"),
    icon = "box",
  } = props;
  const options = multiPasses.map((m) => ({
    label: m.name,
    value: m.addOnID,
  }));
  const onChangePicker = useCallback(
    (addOnID) => {
      const multiPass = multiPasses.find((mp) => mp.addOnID === addOnID);
      if (multiPass) {
        onChange(addOnID, multiPass.id);
      }
    },
    [multiPasses, onChange]
  );

  return (
    <Picker
      icon={icon}
      disabled={disabled}
      placeholder={placeholder}
      value={value}
      options={options}
      onChange={onChangePicker}
      override={override}
    />
  );
}
